import React from "react";
import { useFHomeCard } from "./hooks/FHomeCard";
import styles from "./style/FHomeCard.module.scss";
import classNames from "classnames";

const FHomeCard = ({
  title = "",
  subTitle = "",
  total = "",
  img,
  gradient = ["#fd6e0d", "#7a370e"],
  onClick,
}) => {
  return (
    <div className="my-2 px-5 xxs:px-1">
      <div
        onClick={onClick}
        style={{
          backgroundImage: `linear-gradient(to right,${gradient[0]} ,${gradient[1]} )`,
        }}
        className="relative grid grid-cols-12 border-0  grid-rows-3 w-full h-[80px] xxs:h-[140px]  pr-6 py-3 xxs:py-6 pl-2 rounded-3xl text-white hover:shadow-2xl cursor-pointer"
      >
        <div className="absolute border-0 h-full w-full grid justify-end ">
          <div
            className="border-0 h-full w-[80px] px-5 xxs:w-[132px]"
            style={{
              backgroundImage: `linear-gradient(to right,${gradient[0]},${gradient[1]})`,
              borderRadius: "60% 20% 20% 13% / 58% 20% 20% 43% ",
            }}
          ></div>
        </div>

        <div className="z-10 col-span-2 border-0 w-[65px] xxs:w-[85px] row-span-3 flex items-center place-content-center">
          <img className="w-full" src={img} />
        </div>
        <div className="z-10 col-span-10 border-0 flex items-center text-center place-content-center font-bold text-[4vw] xxs:text-[19px]">
          <div className="border-0 ml-8">{title}</div>
        </div>
        <div className="z-10 col-span-10 border-0 flex items-center text-center place-content-center font-semibold text-[4vw] xxs:text-[14px]">
          <div className="border-0 ml-8">{subTitle}</div>
        </div>
        <div className="z-10 col-span-10 border-0 flex items-center text-center place-content-center font-regular text-[4vw] xxs:text-[14px]">
          <div className="border-0 ml-8">{total}</div>
        </div>
      </div>
    </div>
  );
};

export default FHomeCard;
